// Utility function to handle scroll animations
export const initScrollAnimations = () => {
  const animatedElements = document.querySelectorAll('.scroll-animate');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // Add animation when element enters viewport
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
        entry.target.classList.remove('animate-out');
      } else {
        // Remove animation when element leaves viewport
        entry.target.classList.add('animate-out');
        entry.target.classList.remove('animate-in');
      }
    });
  }, {
    threshold: 0.1 // Trigger when at least 10% of the element is visible
  });

  animatedElements.forEach(element => {
    observer.observe(element);
  });
};
